import apiService from './api';

class sheetService {
  // ========= 数据获取相关 =========

  /**
   * 获取所有工作表
   * @param userId 用户ID
   * @returns 工作表列表
   */

  async getAllSheets(): Promise<any> {
    try {
        const response = await apiService.getCollectionList();
        return response.data;
    }
    catch(error){
        console.error('获取工作表列表失败:', error);
        throw error;
    }
   }

  /**
   * 获取表格数据 - 从 api.ts 迁移过来
   * @param collection collection 名称
   * @returns 处理后的表格数据
   */
  async getTableData(collection: string, fields: string[]): Promise<any> {
    try {
      const response = await apiService.getTableData(collection, fields);
      return response.data;
    } catch (error) {
      console.error('获取表格数据失败:', error);
      throw error;
    }
  }
  /**
   * 获取表格字段 
   * @param collection collection 名称
   * @returns 处理后的表格字段
   */
    async getTableFields(collection: string): Promise<any> {
        try {
        const response = await apiService.getTableFields(collection);
        return response.data;
        } catch (error) {
        console.error('获取表格字段失败:', error);
        throw error;
        }
    }


}

export default new sheetService();
